import classNames from "classnames";
import {RegisterOptions, useFormContext} from "react-hook-form";

import {Checkbox} from "@/components/checkbox/Checkbox.tsx";
import {RadioFieldProps} from "@/components/form/fields/RadioField/RadioField.types.ts";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";

import styles from "./RadioField.module.scss";

export const RadioField = ({
  name,
  value,
  label,
  className,
  tooltip,
  supportLink,
  helpText,
  required,
  disabled = false,
  onChange,
  subField,
  variant = "default",
  subtextVariant = "default",
  labelTypography,
}: RadioFieldProps) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const extraOptions: RegisterOptions = {
    ...(onChange && {onChange: onChange}),
  };
  if (required) {
    extraOptions["required"] = "This field is required";
  }

  return (
    <div>
      <Checkbox className={classNames(styles.radioField, styles[variant], {[styles.disabled]: disabled}, className)}>
        {variant === "marketing" && (
          <Checkbox.Label
            forId={`${name}-${value}`}
            helpText={tooltip}
            disabled={disabled}
            labelTypography={labelTypography}
          >
            {label}
          </Checkbox.Label>
        )}
        <Checkbox.Input
          id={`${name}-${value}`}
          {...register(name, extraOptions)}
          value={value}
          disabled={disabled}
          type={"radio"}
          name={name}
          variant={variant === "cloudStatus" ? variant : undefined}
        />
        {variant !== "marketing" && (
          <Checkbox.Label
            forId={`${name}-${value}`}
            helpText={tooltip}
            disabled={disabled}
            labelTypography={labelTypography}
          >
            {label}
          </Checkbox.Label>
        )}
      </Checkbox>
      <FormSubtext
        variant={subtextVariant}
        subText={helpText ? helpText : !disabled && subField}
        supportLink={supportLink}
        error={fieldError?.toString()}
      />
    </div>
  );
};
